import { FC, useEffect } from 'react'
import { useGetUserQuery } from 'common/services/useUser'
import { useHydrated } from 'common/services/useHydrated'
import { useFlagsmith } from 'flagsmith/react'
import Loader from 'components/base/Loader'
import { useTenancy } from 'common/services/useTenancy'
import { Project, setProject } from 'common/project'

type ProfileContainerType = {}

const ProfileContainer: FC<ProfileContainerType> = ({ children }) => {
  const flagsmith = useFlagsmith()
  const hydrated = useHydrated()
  const { tenancy } = useTenancy()
  const { data, isLoading } = useGetUserQuery(
    {},
    {
      skip: !tenancy?.id,
    },
  )

  useEffect(() => {
    const fetchProject = async () => {
      if (tenancy?.id) {
        let newProject
        const isDev =
          process.env.NODE_ENV === 'development' ||
          process.env.NODE_ENV === 'test'
        newProject = await import(
          `common/project_${isDev ? 'dev' : 'prod'}_${
            tenancy.id === 1 ? 'hoxtonmix' : 'hoxtonmix-aus'
          }.js`
        )
        setProject(newProject.Project)
      }
    }
    fetchProject()
  }, [tenancy])

  useEffect(() => {
    if (flagsmith.identity !== data?.id) {
      if (data?.id) {
        flagsmith.identify(`${data.id}`, { ...data } as any)
      } else {
        flagsmith.logout()
      }
    }
  }, [flagsmith, data])

  if (!hydrated || (!data && isLoading))
    return (
      <div className='d-flex flex-column min-vh-100 justify-content-center align-items-center'>
        <Loader />
      </div>
    )
  return <>{typeof children === 'function' ? children(data) : children}</>
}

export default ProfileContainer
